import React, { PureComponent, useContext } from 'react';
import PropTypes from 'prop-types';
import ComponentWithDrawer
from '@fuww/components/src/Navigation/withDrawerState';
import FashionUnited
from '@fuww/components/src/Icons/FashionUnited';
import Anchor from '@fuww/components/src/Anchor';
import dynamic from 'next/dynamic';
import SimpleTopAppBar from './SimpleTopAppBar';
import { Link } from '../../routes';
import getRelativePrefix from '../../lib/getRelativePrefix';
import SiteContext from '../SiteContext';
import loading from '../../lib/fullScreenLoading';

const DynamicDrawer = dynamic(() => import('./Drawer'), {
  ssr: false,
  loading,
});

class Navigation extends PureComponent {
  constructor() {
    super();

    this.state = { open: false };
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  toggleDrawer() {
    this.setState(({ open }) => ({
      open: !open,
    }));
  }

  render() {
    const {
      topAppBarTitle,
      useRouter,
    } = this.props;
    const { open } = this.state;

    return (
      <>
        <SimpleTopAppBar
          onOpenDrawer={this.toggleDrawer}
          topAppBarTitle={topAppBarTitle}
          useRouter={useRouter}
        />
        <DynamicDrawer
          open={open}
          closeDrawer={this.toggleDrawer}
          useRouter={useRouter}
        />
      </>
    );
  }
}

Navigation.defaultProps = {
  topAppBarTitle: undefined,
  useRouter: true,
};

Navigation.propTypes = {
  topAppBarTitle: PropTypes.node,
  useRouter: PropTypes.bool,
};

const NavigationWithDrawer = ComponentWithDrawer(Navigation);

const Index = () => {
  const { url } = useContext(SiteContext);
  const relativePrefix = getRelativePrefix(url);

  return (
    <NavigationWithDrawer
      topAppBarTitle={(
        <Link
          route="index"
          href={relativePrefix}
          passHref
        >
          <Anchor styled>
            <FashionUnited
              width="168"
              height="18"
              title="FashionUnited"
            />
          </Anchor>
        </Link>
      )}
    />
  );
};

export default Index;
